<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <MensagemAlerta class="row-space" v-if="msgAlerta" :mensagem="msgAlerta" />

    <div class="form-edit-page">
        <div class=" row-start row-space">
            <div class="form-item-char30">
                <label class="label-caption">Opção de Relatório</label>
                <select v-model="opcaoSelecionada">
                    <option v-for="opcao in lsOpcoes" :key="opcao.id" :value="opcao.id">{{ opcao.descricao }}</option>
                </select>
            </div>
            
            <div class="form-item-rangedata"><RangeDataSelect :periodoInicial="'currentYear'" v-model="dateRange"/></div>

            <div class="form-item">
                <SimSelect :ckAddTodos="true" v-model:idSelecionado="idSim" />
            </div>
        </div>

        <div class="row-start">
            <div class="form-item">
                <EstabelecimentoSelect :ckAddTodos="true" v-model:idSelecionado="idEstabelecimento" />
            </div>

            <button type="button" class="buttom-icon--printer" @click="openReport" />
            <button type="button" class="buttom-icon--close" @click="closePage" />
        </div>
    </div>    
</template>

<script setup>
import { ref } from 'vue';
import { Funcoes } from '@/funcoes/funcoes';
import { genericReport } from '@/funcoes/api';
import { globalStore } from '@/globals';
import EstabelecimentoSelect from '@/components/selects/EstabelecimentoSelect.vue';
import MensagemAlerta from '@/components/utils/MensagemAlerta.vue';
import RangeDataSelect from '@/components/selects/RangeDataSelect.vue';
import SimSelect from '@/components/selects/SimSelect.vue';

const emit = defineEmits(['close']);
const dateRange = ref({ startDate: "", endDate: "", selectedPeriod: "" });
const msgAlerta = ref(null);
const idEstabelecimento = ref(0);
const idSim = ref(0);
const isLoading = ref(false);

const lsOpcoes = ref([
    {id: 'rastreabilidade_basico', descricao: 'Listagem geral'},
    {id: 'rastreabilidade_lote', descricao: 'Por lote de produto'},
]);
const opcaoSelecionada = ref('rastreabilidade_basico');

const closePage = () => {emit('close');}

const openReport = async() => {
    try{
        Funcoes.validarIntervaloDatas(dateRange.value.startDate, dateRange.value.endDate);
        msgAlerta.value = null;
        isLoading.value = true;
        const dados = {
            nmrelatorio: opcaoSelecionada.value,
            idep: globalStore.idep,
            idsim: idSim.value,
            idusuario: globalStore.idusuario,
            idestabelecimento: idEstabelecimento.value,
            datainicial: dateRange.value.startDate,
            datafinal: dateRange.value.endDate
        };
        const response = await genericReport(dados);
        const pdfBlob = new Blob([response], { type: 'application/pdf' });
        const pdfUrl = URL.createObjectURL(pdfBlob);
        window.open(pdfUrl, '_blank');
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {isLoading.value = false;}
}
</script>